export default function () {
  // Trick for router dependency manager
  // It's require to do not load ProfileModel in main bundle
  let profileDataPromiseTempResolve = null;
  const profileDataPromiseTemp = new Promise((resolve) => {
    profileDataPromiseTempResolve = resolve;
  });
  return {
    profileModel: {},
    profileDataPromiseTemp,
    profileDataPromiseTempResolve,
    isProfileFillMessageClosed: false,
    investmentProfileList: [],
    investmentProfileListLoading: false,
    investmentProfileListLoaded: false,
    addFundingSourceLoading: false,
    selectedInvestmentProfileId: null,
    walletData: {},
    walletDataLoading: false,
    walletDataProfileId: null,
    walletBalance: {},
    walletBanks: [],
    walletTransactionsData: [],
    walletTransactionsCount: 0,
    walletTransactionsLoading: false,
    walletCanLinkBankAccount: true,
    walletCanWithdraw: true,
    beneficialOwnersData: [],
    beneficialOwnersDataProfileId: null,
    beneficialOwnersLoadingProfileId: null,
    beneficialOwnersLoading: false,
    beneficialOwnersLoaded: false,
    investmentProfileSSNList: [],
    investmentProfileAccreditationIssueList: [],
    investmentProfileAccreditationIssueListLoaded: false,
  };
}
